import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { TwoFactorService } from '../services/two-factor.service'
import { AuthService } from '../services/auth.service'

export const twoFactorGuard: CanActivateFn = (route, state) => {
  const twoFactorService = inject(TwoFactorService)
  const authService = inject(AuthService)
  const router = inject(Router)

  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/home'])
  }

  // Check if we have the required 2FA session data (new flow)
  const email = sessionStorage.getItem('login_email')
  const password = sessionStorage.getItem('login_password')
  const phoneNumber = sessionStorage.getItem('2fa_phone')

  if (email && password && phoneNumber) {
    return true
  }

  // Check if we have a valid legacy 2FA session (old flow)
  if (twoFactorService.hasValidSession()) {
    return true
  }

  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } })
}
